export default {
    // Add to your translation files (create src/i18n/locales/kn/birth-chart.js)

// Header Section
"birth_chart_generator": "ಜನ್ಮ ಕುಂಡಲಿ ರಚನೆಗಾರ",
"create_your": "ನಿಮ್ಮ",
"birth_chart": "ಜನ್ಮ ಕುಂಡಲಿಯನ್ನು",
"kundli_analysis": "ಮತ್ತು ಜಾತಕ ವಿಶ್ಲೇಷಣೆಯನ್ನು ರಚಿಸಿ",
"birth_chart_description": "ನಿಮ್ಮ ನಿಖರವಾದ ಜನ್ಮ ವಿವರಗಳ ಆಧಾರದ ಮೇಲೆ ವಿಸ್ತೃತ ಗ್ರಹ ಸ್ಥಾನಗಳು, ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ಪರಿಹಾರ ಪರಿಹಾರಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವೈದಿಕ ಜನ್ಮ ಕುಂಡಲಿಯನ್ನು ರಚಿಸಿ.",

// Form Fields
"enter_birth_details": "ನಿಮ್ಮ ಜನ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
"full_name": "ಪೂರ್ಣ ಹೆಸರು",
"enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
"gender": "ಲಿಂಗ",
"male": "ಪುರುಷ",
"female": "ಮಹಿಳೆ", 
"other": "ಇತರೆ",
"date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
"time_of_birth": "ಜನ್ಮ ಸಮಯ",
"exact_time_note": "ನಿಖರವಾದ ಭವಿಷ್ಯವಾಣಿಗಳಿಗಾಗಿ ನಿಖರವಾದ ಜನ್ಮ ಸಮಯ ಅತ್ಯಗತ್ಯ",
"place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
"place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
"place_birth_note": "ನಿಖರವಾದ ಲೆಕ್ಕಾಚಾರಗಳಿಗಾಗಿ ಸಂಪೂರ್ಣ ಜನ್ಮ ಸ್ಥಳವನ್ನು ನಮೂದಿಸಿ",

// Chart Options
"chart_type": "ಕುಂಡಲಿ ವಿಧ",
"south_indian_style": "ದಕ್ಷಿಣ ಭಾರತೀಯ ಶೈಲಿ",
"north_indian_style": "ಉತ್ತರ ಭಾರತೀಯ ಶೈಲಿ", 
"east_indian_style": "ಪೂರ್ವ ಭಾರತೀಯ ಶೈಲಿ",

// Actions
"generate_birth_chart": "ಜನ್ಮ ಕುಂಡಲಿ ರಚಿಸಿ",
"generating_chart": "ಕುಂಡಲಿ ರಚಿಸುತ್ತಿದೆ",
"download_chart": "ಕುಂಡಲಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
"view_detailed_report": "ವಿಸ್ತೃತ ವರದಿ ವೀಕ್ಷಿಸಿ",

// Features
"what_you_get": "ನೀವು ಏನು ಪಡೆಯುತ್ತೀರಿ",
"detailed_planetary_positions": "ವಿಸ್ತೃತ ಗ್ರಹ ಸ್ಥಾನಗಳು",
"zodiac_sign_analysis": "ರಾಶಿ ಚಿಹ್ನೆ ವಿಶ್ಲೇಷಣೆ",
"dasha_system_predictions": "ದಶಾ ವ್ಯವಸ್ಥೆ ಭವಿಷ್ಯವಾಣಿಗಳು", 
"remedial_suggestions": "ಪರಿಹಾರಾತ್ಮಕ ಸಲಹೆಗಳು",

// Visual Elements
"sample_birth_chart": "ಮಾದರಿ ಜನ್ಮ ಕುಂಡಲಿ",
"sample_chart_description": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜನ್ಮ ಕುಂಡಲಿ ಹೇಗೆ ಕಾಣುತ್ತದೆ",
"astrological_elements": "ಜ್ಯೋತಿಷ್ಯ ಅಂಶಗಳು",

// Planets
"sun": "ಸೂರ್ಯ",
"moon": "ಚಂದ್ರ",
"mars": "ಮಂಗಳ",
"mercury": "ಬುಧ",
"jupiter": "ಗುರು",
"venus": "ಶುಕ್ರ",

// Results
"your_birth_chart": "ನಿಮ್ಮ ಜನ್ಮ ಕುಂಡಲಿ",
"chart_generated_successfully": "ಕುಂಡಲಿ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ!",
"chart_ready_message": "ವಿಸ್ತೃತ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಭವಿಷ್ಯವಾಣಿಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಜನ್ಮ ಕುಂಡಲಿ ಸಿದ್ಧವಾಗಿದೆ."
}
